/*jslint browser: true */
/*global window, jQuery:false */

// Passive event listeners
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

(function ($) {

  //GSAP animation defaults
  gsap.defaults({
    ease: 'power4.out', duration: 1,
  });

  function loadMainNav() {

    const button = document.querySelector('#menu-btn, #menu-one-pager li a'),
          mobileLinks = document.querySelectorAll('#menu-one-pager li a'),
          mm = gsap.matchMedia();

    function headerChange(element) {
      let headerSlide = gsap.from(element, {
        yPercent: -100,
        paused: true, duration: 0.3,
      }).progress(1);
  
      ScrollTrigger.create({
        start: '40 top',
        onUpdate: (self) => {
          self.direction === -1 ? headerSlide.play() : headerSlide.reverse()
        }
      });
    }
    
    mm.add("(max-width: 599px)", () => {

      let mobileMenu = gsap.timeline({ paused: true });

      function menuAction(element) {
        element.addEventListener('click', function (){
          button.classList.toggle('is--active');
          document.body.classList.toggle('lock-scroll');
          mobileMenu.reversed(!mobileMenu.reversed());
        });
      };

      mobileMenu.
        set('#menu-panel', {
          autoAlpha:1,
        })
        .from('.menu-overlay', {
          xPercent:100, 
          duration:0.5,
        }, 'menuAppears')
        .from('#menu-one-pager li a', {
          yPercent:100, 
          stagger:0.1, duration:0.5,
        }, 'menuAppears+=0.3')
        .to('#site article, #contact', {
          x:'-25vw',
          duration: 1, ease: 'power2.inOut'
        }, 'menuAppears-=0.4').reverse();

      menuAction(button);

      for (let i = 0; i < mobileLinks.length; i++) {
        menuAction(mobileLinks[i]);
      };

      headerChange('#masthead');

    });

    mm.add("(min-width: 600px)", () => {

      gsap.to('#menu-one-pager li', {
        autoAlpha:1,
      });
      gsap.from('#menu-one-pager li a', {
        yPercent:100,
        stagger:0.1,
      }, '0.3');

      button.classList.remove('is--active');

      headerChange('#menu-panel');
  

    });

  }

  function loadOnePager() {

    //Hero Section

    const video = document.querySelector('.hero-video video');

    const mainHeroTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.m-hero',
        start:'top center',
        end:'bottom top',
        toggleActions: 'play reverse play none',
        onEnter: () => {
          window.requestAnimationFrame(function() {
            if (video.paused) { video.play(); }
          });
        },
        onLeave: () => {
          window.requestAnimationFrame(function() {
            if (!video.paused) { video.pause(); }
          });
        },
        onEnterBack: () => {
          window.requestAnimationFrame(function() {
            if (video.paused) { video.play(); }
          });
        },
        onLeaveBack: () => {
          window.requestAnimationFrame(function() {
            if (!video.paused) { video.pause(); }
          });
        },
      }
    });

    mainHeroTl
      .from('.logo', {
        autoAlpha:0, scale:1.4,
        duration:1.5,
      })
      .from('.hero-video video', {
        autoAlpha:0,
      }, '0.2')
      .from('.cta-group', {
        autoAlpha:0, yPercent:25,
      }, '0.5')
      .from('.hero-bottom', {
        yPercent:200,
      }, '0.5');

    new VenoBox({
      selector: '.lb-cta',
      autoplay: true,
      spinner: 'pulse',
    });

    document.querySelector('.scroll-down').addEventListener('click', ()=>{
    	document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
    })

    
    //About section
    const aboutHeroTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.m-about',
        start:'top bottom',
        toggleActions: 'play none none reset',
      }
    });

    aboutHeroTl
      .from('.m-about img', {
        scale:1.5,
        duration:3.2,
      })
      .to('.m-about .swipe-1', {
        yPercent:100,
        duration:1,
      }, '0.2')
      .to('.m-about .swipe-2', {
        yPercent:200,
        duration:2,
      }, '0.3')
      .from('.m-about h1 .wrap-1 span, .m-about h1 .wrap-2 span', {
        yPercent:100,
        stagger:0.1,
      }, '0.8')
      .from('.about-profile p', {
        autoAlpha:0, y:'4.8rem',
        stagger:0.1,
      }, '0.8');


    //Listen section
    const listenHeroTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.m-listen',
        start:'top bottom',
        toggleActions: 'play none none reset',
      }
    });

    listenHeroTl
      .from('.m-listen img', {
        autoAlpha:0,
        duration:2,
      })
      .from('.listen-title span', {
        yPercent:100,
      }, '0.2')
      .from('.listen-title p, .reelcrafter_embed', {
        autoAlpha:0, y:'4.8rem',
        stagger:0.1,
      }, '0.3');


    //Credits section

    $('.credits-slider').slick({
      infinite: false, speed: 800, dots: true,
      slidesToShow: 5, slidesToScroll: 5,
      appendArrows: '.slider-controls',
      appendDots: '.slider-controls',
      cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 16 17"><path d="m7.6213 4.707-4 4 4 4.0001-1.4142 1.4142L.7929 8.7071 6.207 3.2929 7.6213 4.707Z"/><path d="M15.2071 9.707H1.8738v-2H15.207v2Z"/><path d="M3.8738 8.707c0 .5524-.4478 1-1 1H2.207c-.5523 0-1-.4476-1-1 0-.5522.4477-1 1-1h.6667c.5522 0 1 .4478 1 1Z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 16 17"><path d="m8.3787 12.7071 4-4-4-4 1.4142-1.4142 5.4142 5.4142-5.4142 5.4142-1.4142-1.4142Z"/><path d="M.793 7.707h13.3332v2H.7929v-2Z"/><path d="M12.1262 8.707c0-.5522.4478-1 1-1h.6667c.5523 0 1 .4478 1 1 0 .5524-.4477 1-1 1h-.6667c-.5522 0-1-.4476-1-1Z"/></svg></button>',
      responsive: [
        {
          breakpoint: 899,
          settings: {
            slidesToShow: 3, slidesToScroll: 3,
          }
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 2, slidesToScroll: 2,
          }
        },
      ]
    });

    const creditsHeroTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.m-credits',
        start:'top bottom',
        toggleActions: 'play none none reset',
      }
    });

    creditsHeroTl
      .from('.credits-title span', {
        yPercent:100,
      }, '0.2')
      .from('.credits-title p', {
        autoAlpha:0, y:'4.8rem',
      }, '0.3')
      .from('.slider-controls, .credits-slider', {
        autoAlpha:0, x:'4.8rem',
        stagger:0.1,
      }, '0.4');


    //Gallery Section

    new Accordion('.gallery-accordion');

    const galleryHeroTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.m-gallery',
        start:'top bottom',
        toggleActions: 'play none none reset',
      }
    });

    galleryHeroTl
      .from('.gallery-title span', {
        yPercent:100,
      }, '0.2')
      .from('.gallery-title p, .ac', {
        autoAlpha:0, y:'4.8rem',
      }, '0.3')
      .from('.ac-trigger', {
        yPercent:200, stagger:0.1,
      }, '0.4');


    //Footer Section

    const footerTl = gsap.timeline({
      scrollTrigger: {
        trigger: '#contact',
        start:'top bottom',
        toggleActions: 'play none none reset',
      }
    });

    footerTl
      .from('#contact span', {
        yPercent:100,
      }, '0.2')
      .from('.footer-contact, .footer-credits', {
        autoAlpha:0, y:'4.8rem', stagger:0.1,
      }, '0.3');

  }

  document.addEventListener("DOMContentLoaded", function() {

    loadMainNav();

    $('#site img').slice(0,1).imagesLoaded( function(){
      document.querySelector('#site').classList.add('init-load');
      loadOnePager();
    });

    // //Accessibility
    function handleFirstTab(e) {
      if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
      }
    }
    function handleMouseDownOnce(){
      document.body.classList.remove('user-is-tabbing');
      window.removeEventListener('mousedown', handleMouseDownOnce);
      window.addEventListener('keydown', handleFirstTab);
    }
    window.addEventListener('keydown', handleFirstTab);

  });

})(jQuery);
